(function () {
    "use strict";
    angular.module('angular.emlpayments', []);
}());